module.exports = __webpack_public_path__ + "web/img/sign-10.08202e14.png";